import { Progress } from '@up2stay/up2promo-ui';

interface SetupProgressProps {
  currentStep: number;
  maxSteps: number;
}

export function SetupProgress({ currentStep, maxSteps }: SetupProgressProps) {
  const progress =
    maxSteps > 1
      ? ((currentStep >= 0 ? currentStep : 0) / (maxSteps - 1)) * 100
      : 0;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-50">
      <Progress
        aria-label="Progress"
        value={progress}
        className="h-1 rounded-none bg-muted [&>div]:bg-primary"
      />
    </div>
  );
}
